$(document).ready(function () {

  $(".coupons_discounts_text").html("$300");
  
  // SmileAdvantage
  $(".smileadvantage_price_text").html("<del>$1,095</del> $795");
  $(".smileadvantage__single_price_text").html("$795");
  $(".smileadvantage__single_del_price_text").html("$1,095");

  // SmileFlex
  $(".smileflex_price_text").html("$66");

  // SmileFlex Easy
  $(".smileflex_easy_price_text").html("$92");
  $(".smileflex_easy_downpayment").html("$395");
  $(".smileflex_easy_total").html("$1,039");
  $(".smileflex_easy_months").html("7 months");

  // NightAdvantage
   $(".nightadvantage_price_text").html("<del>$1,295</del> $995");
  $(".nightadvantage__single_price_text").html("$995");
  $(".nightadvantage__single_del_price_text").html("$1,295");

  // NightFlex
  $(".nightflex_price_text").html("$83");

  // NightFlex Easy
  $(".nightflex_easy_price_text").html("$114");
  $(".nightflex_easy_downpayment").html("$444");
  $(".nightflex_easy_total").html("$1,239");
  $(".nightflex_easy_months").html("7 months");

  // Kit First Plan
  $(".kit_first_price_text").html("<del>$75</del> <strong>$59.99</strong>");
  $(".kit_first_price_text_regular").html("$59.99");

  // Smile Protection Plan
  $(".smile_protection_plan_price_text").html("<del>$680</del> $499");

  // Sonic Electric Tootbrush
  $(".sonic_electric_toothbrush_price_text").html("$49.99");
  $(".sonic_electric_toothbrush_price_del_text").html("<del>$75</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$25.99");
  $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$25.99");
  $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");

  // Aligner Cleaner + Whitener
  $(".aligner_cleaner_price_text").html("$25.99");
  $(".aligner_cleaner_price_del_text").html("<del>$39.99</del>");


  // Teeth Whitening Pen
  $(".teeth_whitening_kit_price_text").html("$24.99");
  $(".teeth_whitening_kit_del_price_text").html("<del>$49.99</del>");
  $(".retainers_price_text").html("$125");
  $(".retainers-del-price").html("$150");
  $(".teeth_whitening_pen_text").html("$14.99");
  $(".teeth_whitening_pen_del_text").html("<del>$19.99</del>");
  $(".pull_tool_text").html("$15");
  $(".chewies_text").html("$15");
  $(".retainers_case_text").html("$14.99");
  $(".retainers_case_price_del_text").html("<del>$25.00</del> ");
  $(".cheek_retractor_text").html("$15");
  $(".gift_card_text").html("$15");
  
  $(".night_guard_text").html("$110");
  $(".night_guard_text").html("$110");
  $(".night_guard_del_text").html("$199");
  $(".mouth_guard_text").html("$110");
  $(".mouth-guards-del-price").html("$199");
  $(".soft_night_guard_price").html("$110");
  $(".hybrid_night_guard_price").html("$135");
  $(".hybrid_night_guard_del_price").html("$210");
  $(".hard_night_guard_price").html("$110");
    $(".hard_night_guard_del_text").html("$199");

   // Care Kit
  $(".care_kit_text").html("$39.95");

  // retainer
  $(".retainer_price_text").html("$125");
  $(".retainer_price_del_text").html("$150");
  // teeth-whitening-kit
  $(".teeth_whitening_kit_price_text_regular").html("$34.99");
  $(".teeth_whitening_kit_price_text_wireless").html("$24.99");
  $(".teeth_whitening_kit_del_price_text").html("$49.99");
  $(".teeth_whitening_kit_APR_text").html("$11.66/mo");
  $(".mouth-guards-price").html("$110");
  $(".night-guards-del-price").html("$199");
  $(".night-guards-price").html("$110");
  $(".ultrasonic-cleaner").html("$44.99");
  $(".uv-ultrasonic-cleaner-price").html("$44.99");

  //retainer-set-pricing
  $(".retainer_2set_price_text").html("$225");
  $(".retainer_2set_del_price_text").html("$300");
  $(".retainer_4set_price_text").html("$295");
  $(".retainer_4set_del_price_text").html("$600");
  $(".retainer_8set_price_text").html("$495");
  $(".retainer_8set_del_price_text").html("$1,200");
  $(".cleansing-tablets-for-aligners-retainers-dentures-price").html("$8.99");
  $(".cleansing-tablets-for-aligners-retainers-dentures-120-pisces-price").html("$19.99");

  // scan-center-pricing
  $(".3D-scan-price-text").html("$150");
});
